module.exports = __webpack_public_path__ + "static/img/station-icon.2f78fd99.svg";